// extracted by mini-css-extract-plugin
export default {"confirmSection":"ContactConfirmation_confirmSection__P08D9","confirmIcon":"ContactConfirmation_confirmIcon__QCywC"};